import React, { Component } from 'react';
import styles from './styles.scss';
import { getPrinterConfig, setPrinterConfig } from '../../../utils/qzHelper';
import Snackbar from '../Snackbar';

const qz = require("qz-tray");

export default class PrintConfig extends Component {

    state = {
        printer: '',
        printerName: '',
        offsetX: '',
        offsetY: '',
        editMode: false,
        error: null,
    };

    async componentDidMount(){
        let { printer, offsetX, offsetY } = await getPrinterConfig() || {};
        this.setState({
            printer,
            printerName: printer,   
            offsetX,
            offsetY,
        })
    }

    setPrinter = async () => {
        try {
            const { printerName, offsetY, offsetX } = this.state;
            const pName = await qz.printers.find(printerName);

            const printer = Array.isArray(pName) ? pName[0]: pName ;
            await setPrinterConfig({
                printer,
                offsetX,
                offsetY,
            });
            this.setState({
                printer,
                printerName: printer,
                offsetX,
                offsetY,
                editMode: false,
                error: null,
            })
        }
        catch(e) {
            this.setState({
                error: e.toString(),
            }, () => {
                setTimeout(() => this.setState({ error: null }),5000)
            }) 
        }
    }

    handlePrinterClick = () => {
        this.setState({
            editMode: true,
        })
    }

    onKeyPress = (e) => {
        if(this.state.printerName && e.key === 'Enter') {
            this.setPrinter();
        }
    }

    render() {
        const { printer, editMode, printerName, error, offsetX, offsetY } = this.state;
        return (
                <div className={styles.printConfigCtr} >
                    <div className={styles.printNameCtr}> <i className="icon-printer" /> 
                        <div
                        className={styles.advancedSeachOpt}
                        onClick={this.handlePrinterClick}
                        
                    >
                        {editMode ? (
                            <div className={styles.inputCtr}>
                                <input
                                    type='text'
                                    value={printerName}
                                    onChange={(e) => this.setState({
                                        printerName: e.target.value
                                    })}
                                    onKeyPress={this.onKeyPress}
                                    placeholder="Printer Name"

                                />
                                <input
                                    type='number'
                                    value={offsetX}
                                    onChange={(e) => this.setState({
                                        offsetX: e.target.value
                                    })}
                                    onKeyPress={this.onKeyPress}
                                    placeholder="Label Offset X"

                                />
                                <input
                                    type='number'
                                    value={offsetY}
                                    onChange={(e) => this.setState({
                                        offsetY: e.target.value
                                    })}
                                    onKeyPress={this.onKeyPress}
                                    placeholder="Label Offset Y"
                                />
                           </div>
                        ) : printer ? printer : 'Please add printer settings ' }
                    </div>
                    </div>
                    {error ? <Snackbar msg={error} /> : ''}
                </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/PrintConfig/index.js